// components/common/Button.js
import styled, { css } from 'styled-components';

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 2px solid transparent;
  max-width: 100%;
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;

  @media (max-width: 576px) {
    padding: 10px 20px;
    font-size: 0.95rem;
  }

  ${props => props.variant === 'primary' && css`
    background: var(--accent-primary);
    color: var(--background-primary);

    &:hover {
      background: var(--accent-secondary);
      transform: translateY(-2px);
    }
  `}

  ${props => props.variant === 'secondary' && css`
    background: transparent;
    border: 2px solid var(--accent-primary);
    color: var(--text-primary);

    &:hover {
      background: var(--accent-primary);
      color: var(--background-primary);
      transform: translateY(-2px);
    }
  `}

  ${props => props.variant === 'outline' && css`
    background: transparent;
    border: 2px solid var(--text-primary);
    color: var(--text-primary);

    &:hover {
      background: var(--text-primary);
      color: var(--background-primary);
      transform: translateY(-2px);
    }
  `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  ${props => props.fullWidth && css`
    width: 100%;
  `}
`;

export default Button;
